import { cn } from "lib/utils";
import { GrinningFace, SmilingFace, SadFace } from "../quiz-icons";
import styles from "./quiz-option.module.css";

const QUIZ_ICONS: Record<
  string,
  ({ className }: { className?: string }) => JSX.Element
> = {
  grin: GrinningFace,
  smile: SmilingFace,
  sad: SadFace,
};

interface QuizOptionProps {
  icon: string;
  title: string;
  description: string;
  isSelected?: boolean;
  onClick: () => void;
}

export function QuizOption({
  icon,
  title,
  description,
  isSelected,
  onClick,
}: QuizOptionProps) {
  const QuizIcon = QUIZ_ICONS[icon] || null;

  return (
    <button
      onClick={onClick}
      className={cn(styles.button, isSelected && styles.buttonSelected)}
    >
      <div className={styles.flexCol}>
        <div
          className={cn(
            styles.iconWrapper,
            isSelected && styles.iconWrapperSelected,
          )}
        >
          {QuizIcon && <QuizIcon className={styles.iconSize} />}
        </div>
        <div className={styles.spaceY2}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </button>
  );
}
